<script lang="ts">
	import { cn, type WithElementRef, type WithoutChildren } from '$lib/shadcn/utils.js';
	import type { HTMLTextareaAttributes } from 'svelte/elements';
	import { tv } from 'tailwind-variants';

	let {
		ref = $bindable(null),
		value = $bindable(),
		class: className,
		'data-slot': dataSlot = 'textarea',
		variant,
		...restProps
	}: WithoutChildren<WithElementRef<HTMLTextareaAttributes>> & {
		variant: 'default' | 'tonal';
	} = $props();

	export const inputVariant = tv({
		base: 'flex h-9 w-full min-w-0 rounded-md border px-3 py-1 text-base transition-[color,box-shadow] outline-none disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive field-sizing-content min-h-16 ',
		variants: {
			variant: {
				default:
					'border-input bg-background shadow-xs selection:bg-primary dark:bg-input/30 selection:text-primary-foreground ring-offset-background placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] ',
				tonal:
					'border-none preset-tonal selection:bg-primary/80 selection:text-primary-foreground ring-offset-background placeholder:text-muted-foreground-3 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[2px] '
			},
			size: {
				default: ''
			}
		},
		defaultVariants: {
			variant: 'default',
			size: 'default'
		}
	});
</script>

<textarea
	bind:this={ref}
	data-slot={dataSlot}
	class={cn(inputVariant({ variant, size: 'default' }), className)}
	bind:value
	{...restProps}></textarea>
